import { type TSource } from '@core/api'

import { type TAudioFileSource } from '@core/models'

export const convertAudioSourceFile = (apiAudioSource: TSource): TAudioFileSource => {
    const {
        id,
        url,
        name,
        date_created,
        date_uploaded,
        duration,
        type,
        download,
        size,
        from,
        bit_rate,
    } = apiAudioSource

    return {
        id,
        name,
        url,
        dateCreated: date_created,
        dateUploaded: date_uploaded,
        duration,
        type,
        downloadUrl: download,
        size,
        from,
        bitRate: bit_rate,
    }
}
